import type { Ref } from "vue";
import { CalculatorDic } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";

const useCalculatorDomStore = (
  refs?: Ref<Record<string, HTMLElement | null>>
) => {
  const calculatorSections = injectStrict(CalculatorDic);
  if (refs) {
    calculatorSections.value = refs.value;
  }

  const getCalculatorSection = (id: string): HTMLElement | null => {
    return calculatorSections.value[id];
  };

  return { getCalculatorSection };
};

export default useCalculatorDomStore;
